import { useNavigate } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { Switcher } from "@/components/Switcher/Switcher";
import { SwitcherButton } from "@/components/Switcher/SwitcherButton";
import {
  rudderAnalytics,
  HotelTrackingEvents,
  FlightTrackingEvents,
  TripTrackingEvents,
} from "@/lib/rudderstack";
import type { SearchScope } from "@/types/types";
import { Feature, isFeatureEnabled } from "@/utils/featureFlags";

type CategorySwitcherProps = {
  current: SearchScope;
};

const eventMap = {
  flights: FlightTrackingEvents.USER_SEARCHED_FOR_ORDERS,
  hotels: HotelTrackingEvents.USER_SEARCHED_FOR_ORDERS,
  trips: TripTrackingEvents.USER_SEARCHED_FOR_ORDERS,
} as const;

export const CategorySwitcher = ({ current }: CategorySwitcherProps) => {
  const t = useTranslations();
  const navigate = useNavigate();

  return (
    <Switcher
      value={current}
      onChange={(newCategory) => {
        if (eventMap[newCategory]) {
          rudderAnalytics.track(eventMap[newCategory]);
        }

        navigate({
          to: "/bookings",
          search: {
            category: newCategory,
          },
          replace: true,
        });
      }}
    >
      <SwitcherButton value="flights" label={t("flights.title")} />
      <SwitcherButton value="hotels" label={t("hotels.title")} />
      {isFeatureEnabled(Feature.TripsFlow) && (
        <SwitcherButton value="trips" label={t("trips.title")} />
      )}
    </Switcher>
  );
};
